import {
  SidebarValue,
  SidebarValueWrapper,
  useDisplayNames,
} from '@spotify/confidence-core-react';

import { MetricFilterPreview } from '../MetricFilters';
import { MeasurementInput } from '../SimplifiedQuery';

type InputsSummaryProps = {
  value: Pick<MeasurementInput, 'entity' | 'factTable' | 'filter'>;
};

export const InputsSummary = ({ value }: InputsSummaryProps) => {
  const { displayNames } = useDisplayNames();

  return (
    <SidebarValueWrapper>
      <SidebarValue
        name="Fact table"
        value={displayNames.get(value.factTable || '') || value.factTable}
      />
      <SidebarValue
        name="Entity"
        value={displayNames.get(value.entity || '') || value.entity}
      />
      {value.filter && (
        <SidebarValue
          name="Filter"
          value={<MetricFilterPreview filter={value.filter} />}
        />
      )}
    </SidebarValueWrapper>
  );
};
